import { inject, Injectable } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ActiveRecordsState } from './active-records.state';
import { Observable } from 'rxjs';
import { GetActiveRecords, RemoveActiveRecord, SetActiveCheckout } from './active-records.actions';
import type { ActiveRecordWithColors } from './models/active-records.model';
import type { Checkout } from '../user/checkouts/models/checkout';

@Injectable({
  providedIn: 'root',
})
export class ActiveRecordsFacade {
  private readonly store = inject(Store);

  @Select(ActiveRecordsState.activeRecords) activeRecords$: Observable<ActiveRecordWithColors[]>;
  @Select(ActiveRecordsState.canMakeCheckouts) canMakeCheckouts$: Observable<boolean>;
  @Select(ActiveRecordsState.isLoading) isLoading$: Observable<boolean>;

  getActiveRecords() {
    return this.store.dispatch(new GetActiveRecords());
  }

  removeActiveRecord(checkoutId: string) {
    return this.store.dispatch(new RemoveActiveRecord(checkoutId));
  }

  setActiveRecord(checkout: Checkout) {
    return this.store.dispatch(new SetActiveCheckout(checkout));
  }
}
